// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionOne_container__3G1IO","Main":"QuestionOne_Main__3hifV","TitleBox":"QuestionOne_TitleBox__2FO8B"};